function initCustomSelect() {
  const $formSelect = $('.field-size-top-large')
    .dropkick({
      mobile: true,
    });
  const selectBox = $('select');

  $('.custom-select').dropkick();

  $('form').submit(function() {
    if ($(selectBox).hasClass('LV_invalid_field')) {
      $(selectBox).prev('.dk-select').removeClass('valid').addClass('invalid');
    }
  });

  $formSelect.on('change', function() {
    if ($(this).hasClass('LV_invalid_field')) {
      $(this).prev('.dk-select').removeClass('valid').addClass('invalid');
    } else if ($(this).hasClass('LV_valid_field')) {
      $(this).prev('.dk-select').removeClass('invalid').addClass('valid');
    }
  });

  $('input[type="hidden"]').closest('.form-design-field').addClass('hidden');
}

export default { initCustomSelect };



// WEBPACK FOOTER //
// ./src/js/custom/custom-select.js